import React, { useEffect, useState } from 'react'
import styles from './index.module.sass'
import '../../../styles/tabs.sass'
import { Search } from '../../ui/Search'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import info from '../../../svg-icons/infoSVG.svg'
import contract from '../../../svg-icons/contract.svg'
import prev from '../../../assets/arrow_prev.svg'
import next from '../../../assets/arrow_next.svg'
import classNames from 'classnames'
import { Address, AddressCounters } from '../../../app/models/generated'
import { NavLink, useNavigate, useParams } from 'react-router-dom'
import { formatNumber, stringTruncateFromCenter } from '../../../utils'
import { TokenTransferItems } from './TokenTransferItems'
import { ProducedBlockItems } from './ProducedBlockItems'
import { NFTtransferItems } from './NFTtransferItems'
import { TokenTransItems } from './TokenTransItems'
import { initialAddress } from '../../../app/models/generated/models/Address'
import { TransactionItems } from './TransactionItems'
import { InternalTransactionItems } from './InternalTransactionItems'
import { TokenTransferList } from '../../../services/TransactionPageService'
import graph_item from '../../../../src/assets/graph_item.svg'
import {
    getAddress,
    getCounters,
    getTokenTransfers,
    getTransactions,
} from '../../../services/AddressPageService'
import { TransactionList } from '../../../services/TransactionsPageService'
import { Icon } from '../../ui/Icon'

const previousParams: Record<string, string>[] = []
let currentParams: Record<string, string> = {}
let page = 1

const previousParamsTxn: Record<string, string>[] = []
let currentParamsTxn: Record<string, string> = {}
let pageTxn = 1

export const AddressPage = () => {
    const navigate = useNavigate()
    const { address } = useParams()

    const [add, setAddress] = useState<Address>(initialAddress)
    const [counters, setCounters] = useState<AddressCounters>()
    const [transactions, setTransactions] = useState<TransactionList>({
        items: [],
        next_page_params: null,
    })
    const [tokenTransfers, setTokenTransfers] = useState<TokenTransferList>({
        items: [],
        next_page_params: null,
    })

    useEffect(() => {
        getAddress(setAddress, address, navigate)
    }, [address])

    useEffect(() => {
        getTokenTransfers(setTokenTransfers, address, {})
    }, [address])

    useEffect(() => {
        getCounters(setCounters, address)
    }, [address])

    useEffect(() => {
        getTransactions(setTransactions, address, {})
    }, [address])

    const isDisabled = page == 1
    const typeOfAddress = add.is_contract ? 'Contract' : 'Address'
    const avatarImg =
        typeOfAddress == 'Contract' ? (
            <Icon icon="contract" width={21} height={21}/>
        ) : (
            <div className={styles.angularAvatar}></div>
        )
    const previousPageHandlerTxn = () => {
        if (previousParamsTxn.length > 0) {
            pageTxn = pageTxn - 1
            currentParamsTxn = previousParamsTxn.pop() || {}
            getTransactions(setTransactions, address, currentParamsTxn)
        }
    }
    const nextPageHandlerTxn = () => {
        if (transactions.next_page_params) {
            previousParamsTxn.push(currentParamsTxn)
            currentParamsTxn = transactions.next_page_params
            pageTxn = pageTxn + 1
            getTransactions(setTransactions, address, currentParamsTxn)
        }
    }
    const previousPageHandler = () => {
        if (previousParams.length > 0) {
            page = page - 1
            currentParams = previousParams.pop() || {}
            getTokenTransfers(setTokenTransfers, address, currentParams)
        }
    }
    const nextPageHandler = () => {
        if (tokenTransfers.next_page_params) {
            previousParams.push(currentParams)
            currentParams = tokenTransfers.next_page_params
            page = page + 1
            getTokenTransfers(setTokenTransfers, address, currentParams)
        }
    }
    return (
        <div>
            <section className={styles.pageSection}>
                <div className={styles.headOfPage}>
                    <p>{typeOfAddress} {add.hash} </p>
                </div>
                <div className={styles.addressform}>
                    <div className={styles.smallform}>
                        <div>Overview</div>
                        <div>
                            <p>DOP BALANCE</p>
                            <p>0.018033344549502508 DOP</p>
                            <p>ETH VALUE</p>
                            <p>$5,673.01 (@ $1,848.93/DOP)</p>
                        </div>
                        <div>
                            <div>Token Holding</div>
                            <div className={styles.tokenfont1}>$0.17 (29 Tokens)</div>
                        </div>
                    </div>

                    <div className={styles.smallform}>
                        <div>More Info</div>
                        <div>
                            <div>PRIVATE NAME TAGS</div>
                            <div className={`${styles.tokenfont1} ${styles.width33}`}>Add</div>
                        </div>
                        <div>
                            <p>LAST TXN SENT</p>
                            <p>0xed4...328 from 13 secs ago</p>
                            <p>FIRST TXN SENT</p>
                            <p>0x317...907 from 217 days 4 hrs ago</p>
                        </div>
                    </div>

                    <div className={styles.smallform}>
                        <div>Multi Chain</div>
                        <div>
                            <p>MULTICHAIN ADDRESSES</p>
                            <p>15 addresses found</p>
                        </div>
                    </div>
                </div>

                
{/*             
                <div className={classNames(styles.details, styles.mgtop30)}>
                    {add.token && (
                        <div className={styles.infoRow}>
                            <span data-hint='Token name and symbol'>
                                    <Icon icon='infoSVG' width={14} height={14} color={'white'} />
                            </span>
                            <p className={styles.rowTitle}>Token</p>
                            <span>{add.token?.name}</span>
                            <span className={styles.valueType}>ETH</span>
                        </div>
                    )}
                    {typeOfAddress == 'Contract' && (
                        <div className={styles.infoRow}>
                            <span data-hint='Transaction ans address of creation'>
                                    <Icon icon='infoSVG' width={14} height={14} color={'white'} />
                            </span>
                            <p className={styles.rowTitle}>Creator</p>
                            <NavLink
                                className={styles.address}
                                to={'/address/' + add.creator_address_hash}>
                                {stringTruncateFromCenter(
                                    add.creator_address_hash,
                                    8
                                )}
                            </NavLink>
                            <p className={styles.connectionSpan}> at txn </p>
                            <NavLink
                                className={styles.address}
                                to={'/transaction/' + add.creation_tx_hash}>
                                {stringTruncateFromCenter(
                                    add.creation_tx_hash,
                                    8
                                )}
                            </NavLink>
                        </div>
                    )}
                    <div className={styles.infoRow}>
                        <span data-hint='Address balance in THE. Doesnt include ERC 20, ERC 721 and ERC1155 tokens'>
                            <Icon icon='infoSVG' width={14} height={14} color={'white'} />
                        </span>
                        <p className={styles.rowTitle}>Balance</p>
                        <span>
                            {add.coin_balance
                                ? formatNumber(add.coin_balance)
                                : '0'}
                        </span>
                        <span className={styles.valueType}>ETH</span>
                    </div>
                    <div className={styles.infoRow}>
                        <span data-hint='Number of transactions related to this address'>
                            <Icon icon='infoSVG' width={14} height={14} color={'white'} />
                        </span>
                        <p className={styles.rowTitle}>Transactions</p>
                        <span>
                            {counters
                                ? formatNumber(counters.transactions_count)
                                : 0}
                        </span>
                    </div>
                    <div className={styles.infoRow}>
                        <span data-hint='Number of transfers to/from this address'>
                            <Icon icon='infoSVG' width={14} height={14} color={'white'} />
                        </span>
                        <p className={styles.rowTitle}>Transfers</p>
                        <span>
                            {counters
                                ? formatNumber(counters.token_transfers_count)
                                : 0}
                        </span>
                    </div>
                    <div className={styles.infoRow}>
                        <span data-hint='Gas used by the address'>
                            <Icon icon='infoSVG' width={14} height={14} color={'white'} />
                        </span>
                        <p className={styles.rowTitle}>Gas used</p>
                        <span>
                            {counters
                                ? formatNumber(counters.gas_usage_count)
                                : 0}
                        </span>
                    </div>
                    {add.has_validated_blocks && (
                        <div className={styles.infoRow}>
                            <span data-hint='Blocks validated value'>
                                <Icon icon='infoSVG' width={14} height={14} color={'white'} />
                            </span>
                            <p className={styles.rowTitle}>Blocks validated</p>
                            <span>
                                {counters
                                    ? formatNumber(counters.validations_count)
                                    : 0}
                            </span>
                        </div>
                    )}

                    <div className={styles.infoRow}>
                        <span data-hint='Block number in which the address was updated'>
                            <Icon icon='infoSVG' width={14} height={14} color={'white'} />
                        </span>
                        <p className={styles.rowTitle}>Last balance update</p>
                        <NavLink
                            className={classNames(
                                styles.address,
                                styles.fontWeight500
                            )}
                            to={
                                '/block/' + add.block_number_balance_updated_at
                            }>
                            {add.block_number_balance_updated_at}
                        </NavLink>
                    </div> 
                </div> */}
                <Tabs>
                    <TabList>
                        <Tab>Overview</Tab>
                        <Tab>Internal Transactions</Tab>
                        <Tab>Token Transfers (ERC-20)</Tab>
                        <Tab>NFT Transfers</Tab>
                        <Tab>Produced Blocks</Tab>
                        <Tab>Analytics</Tab>
                    </TabList>

                    <TabPanel>
                        {transactions.items.length == 0 || !transactions ? (
                            <p className={styles.message}>
                                There are no transactions.
                            </p>
                        ) : (
                            <div className={styles.transactions}>
                                
                                <div className={styles.tableWrapper}>
                                    <table className={styles.table}>
                                        <thead>
                                            <tr>
                                                <th className={styles.paddingitem}>
                                                    Txn Hash
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Method
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Block
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                
                                                <th className={styles.paddingitem}>
                                                    Age
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>

                                                <th className={styles.paddingitem}>
                                                    From
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    To
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Value
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Txn Fee
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                            </tr>
                                        </thead>
                                        { <TransactionItems
                                            TransactionArray={
                                                transactions.items
                                            }></TransactionItems> }
                                    </table>
                                </div>
                                <div className={styles.paginationButtons}>
                                    <button
                                        className={styles.controlButton}
                                        disabled={isDisabled}
                                        onClick={previousPageHandlerTxn}>
                                        <img src={prev} alt="previous page" />
                                    </button>
                                    <div className={styles.pageNum}>
                                        {pageTxn}
                                    </div>
                                    <button
                                        className={styles.controlButton}
                                        onClick={nextPageHandlerTxn}
                                        disabled={
                                            !transactions.next_page_params
                                        }>
                                        <img src={next} alt="next page" />
                                    </button>
                                </div>
                            </div>
                        )}
                    </TabPanel>

                    <TabPanel>
                    {transactions.items.length == 0 || !transactions ? (
                            <p className={styles.message}>
                                There are no Internal transactions.
                            </p>
                        ) : (
                            <div className={styles.transactions}>
                                
                                <div className={styles.tableWrapper}>
                                    <table className={styles.table}>
                                        <thead>
                                            <tr>
                                                <th className={styles.paddingitem}>
                                                    Parent Txn Hash
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Block
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                
                                                <th className={styles.paddingitem}>
                                                    Age
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>

                                                <th className={styles.paddingitem}>
                                                    From
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    To
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Value
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                            </tr>
                                        </thead>
                                        { <InternalTransactionItems
                                            TransactionArray={
                                                transactions.items
                                            }></InternalTransactionItems> }
                                    </table>
                                </div>
                                <div className={styles.paginationButtons}>
                                    <button
                                        className={styles.controlButton}
                                        disabled={isDisabled}
                                        onClick={previousPageHandlerTxn}>
                                        <img src={prev} alt="previous page" />
                                    </button>
                                    <div className={styles.pageNum}>
                                        {pageTxn}
                                    </div>
                                    <button
                                        className={styles.controlButton}
                                        onClick={nextPageHandlerTxn}
                                        disabled={
                                            !transactions.next_page_params
                                        }>
                                        <img src={next} alt="next page" />
                                    </button>
                                </div>
                            </div>
                        )}
                        {/* {tokenTransfers.items.length == 0 ? (
                            <p className={styles.message}>
                                There are no token transfers.
                            </p>
                        ) : (
                            <div className={styles.transactions}>
                                <div className={styles.paginationButtons}>
                                    <button
                                        className={styles.controlButton}
                                        disabled={isDisabled}
                                        onClick={previousPageHandler}>
                                        <img src={prev} alt="previous page" />
                                    </button>
                                    <div className={styles.pageNum}>{page}</div>
                                    <button
                                        className={styles.controlButton}
                                        onClick={nextPageHandler}
                                        disabled={
                                            !tokenTransfers.next_page_params
                                        }>
                                        <img src={next} alt="next page" />
                                    </button>
                                </div>
                                <div className={styles.tableWrapper}>
                                    <div className={styles.tableBorder}></div>
                                    <table className={styles.table}>
                                        <thead className={styles.tableHead}>
                                            <tr>
                                                <th
                                                    className={classNames(
                                                        styles.thW30,
                                                        styles.thDefault
                                                    )}>
                                                    Token
                                                </th>
                                                <th
                                                    className={classNames(
                                                        styles.thW30,
                                                        styles.thDefault
                                                    )}>
                                                    Token ID
                                                </th>
                                                <th
                                                    className={classNames(
                                                        styles.thFrom,
                                                        styles.thDefault
                                                    )}>
                                                    From
                                                </th>
                                                <th
                                                    className={
                                                        styles.thIcon
                                                    }></th>
                                                <th className={styles.thTo}>
                                                    To
                                                </th>
                                                <th
                                                    className={classNames(
                                                        styles.thW40,
                                                        styles.thDefaultRight
                                                    )}>
                                                    Value
                                                </th>
                                            </tr>
                                        </thead>
                                        <TokenTransferItems
                                            TokenTransferArray={
                                                tokenTransfers.items
                                            }></TokenTransferItems>
                                    </table>
                                </div>
                            </div>
                        )} */}
                    </TabPanel>
                    <TabPanel>
                    {transactions.items.length == 0 || !transactions ? (
                            <p className={styles.message}>
                                There are no transactions.
                            </p>
                        ) : (
                            <div className={styles.transactions}>
                                
                                <div className={styles.tableWrapper}>
                                    <table className={styles.table}>
                                        <thead>
                                            <tr>
                                                <th className={styles.paddingitem}>
                                                    Txn Hash
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Method
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Block
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                
                                                <th className={styles.paddingitem}>
                                                    Age
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>

                                                <th className={styles.paddingitem}>
                                                    From
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    To
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Value
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                            </tr>
                                        </thead>
                                        { <TokenTransItems
                                            TransactionArray={
                                                transactions.items
                                            }></TokenTransItems> }
                                    </table>
                                </div>
                                <div className={styles.paginationButtons}>
                                    <button
                                        className={styles.controlButton}
                                        disabled={isDisabled}
                                        onClick={previousPageHandlerTxn}>
                                        <img src={prev} alt="previous page" />
                                    </button>
                                    <div className={styles.pageNum}>
                                        {pageTxn}
                                    </div>
                                    <button
                                        className={styles.controlButton}
                                        onClick={nextPageHandlerTxn}
                                        disabled={
                                            !transactions.next_page_params
                                        }>
                                        <img src={next} alt="next page" />
                                    </button>
                                </div>
                            </div>
                        )}
                    </TabPanel>
                    <TabPanel>
                    {transactions.items.length == 0 || !transactions ? (
                            <p className={styles.message}>
                                There are no transactions.
                            </p>
                        ) : (
                            <div className={styles.transactions}>
                                
                                <div className={styles.tableWrapper}>
                                    <table className={styles.table}>
                                        <thead>
                                            <tr>
                                                <th className={styles.paddingitem}>
                                                    Txn Hash
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Method
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Block
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                
                                                <th className={styles.paddingitem}>
                                                    Age
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>

                                                <th className={styles.paddingitem}>
                                                    From
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    To
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Txn Fee
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                            </tr>
                                        </thead>
                                        { <NFTtransferItems
                                            TransactionArray={
                                                transactions.items
                                            }></NFTtransferItems> }
                                    </table>
                                </div>
                                <div className={styles.paginationButtons}>
                                    <button
                                        className={styles.controlButton}
                                        disabled={isDisabled}
                                        onClick={previousPageHandlerTxn}>
                                        <img src={prev} alt="previous page" />
                                    </button>
                                    <div className={styles.pageNum}>
                                        {pageTxn}
                                    </div>
                                    <button
                                        className={styles.controlButton}
                                        onClick={nextPageHandlerTxn}
                                        disabled={
                                            !transactions.next_page_params
                                        }>
                                        <img src={next} alt="next page" />
                                    </button>
                                </div>
                            </div>
                        )}
                    </TabPanel>
                    <TabPanel>
                    {transactions.items.length == 0 || !transactions ? (
                            <p className={styles.message}>
                                There are no produced blocks.
                            </p>
                        ) : (
                            <div className={styles.transactions}>
                                
                                <div className={styles.tableWrapper}>
                                    <table className={styles.table}>
                                        <thead>
                                            <tr>
                                                <th className={styles.paddingitem}>
                                                    Block
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Age
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Transaction
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                
                                                <th className={styles.paddingitem}>
                                                    Difficulty
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>

                                                <th className={styles.paddingitem}>
                                                    Gas Used
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                                <th className={styles.paddingitem}>
                                                    Reward
                                                    <span> </span>
                                                    <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                                </th>
                                            </tr>
                                        </thead>
                                        { <ProducedBlockItems
                                            TransactionArray={
                                                transactions.items
                                            }></ProducedBlockItems> }
                                    </table>
                                </div>
                                <div className={styles.paginationButtons}>
                                    <button
                                        className={styles.controlButton}
                                        disabled={isDisabled}
                                        onClick={previousPageHandlerTxn}>
                                        <img src={prev} alt="previous page" />
                                    </button>
                                    <div className={styles.pageNum}>
                                        {pageTxn}
                                    </div>
                                    <button
                                        className={styles.controlButton}
                                        onClick={nextPageHandlerTxn}
                                        disabled={
                                            !transactions.next_page_params
                                        }>
                                        <img src={next} alt="next page" />
                                    </button>
                                </div>
                            </div>
                        )}
                    </TabPanel>
                    <TabPanel>
                        <div className={styles.bigitem}>
                            <div className={styles.subletter}>
                                DOP blockchain and ERC20 tokens performance
                            </div>
                            <img
                                src={graph_item}
                                alt="graph_item"
                                width="100%"
                            />

                            <div className={styles.rowitem}>
                                    
                                <div className={styles.subitemss}>
                                    <div className={styles.smfont1}>Blocks</div>
                                    <div className={styles.smfont2}>17,876,202</div>
                                    <div className={styles.smfont1}>12.20 s.</div>
                                </div>

                                <div className={styles.subitemss}>
                                    <div className={styles.smfont1}>Transactions</div>
                                    <div className={styles.smfont2}>1,978.60 M</div>
                                    <div className={styles.smfont1}>7d: <span className={styles.greenletter}>5.2%</span> 30d: <span className={styles.greenletter}>3.4%</span></div>
                                </div>

                                <div className={styles.subitemss}>
                                    <div className={styles.smfont1}>TPS / TTPS</div>
                                    <div className={styles.smfont2}>12.40 / 5.27</div>
                                    <div className={styles.smfont1}>12.20 s.</div>
                                </div>

                                <div className={styles.subitemss}>
                                    <div className={styles.smfont1}>Token Transfers</div>
                                    <div className={styles.smfont2}>1,374.90 M</div>
                                    <div className={styles.smfont1}>7d: <span className={styles.redletter}>-0.3%</span> 30d: <span className={styles.greenletter}>5.7%</span></div>
                                </div>

                                <div className={styles.subitemss}>
                                    <div className={styles.smfont1}>Unique Addresses</div>
                                    <div className={styles.smfont2}>237 M</div>
                                    <div className={styles.smfont1}>7d: <span className={styles.greenletter}>0.3%</span> 30d: <span className={styles.greenletter}>1.4%</span></div>
                                </div>

                                <div className={styles.subitemss}>
                                    <div className={styles.smfont1}>Active Addresses (30d)</div>
                                    <div className={styles.smfont2}>7 M</div>
                                    <div className={styles.smfont1}>24h: <span className={styles.greenletter}>13.4%</span> 30d: <span className={styles.greenletter}>-7.8%</span></div>
                                </div>
                            </div>

                        </div>
                    </TabPanel>
                </Tabs>
            </section>
        </div>
    )
}
